import { IS_DEV } from "@/__main__/constants.mjs";
import { callsites } from "@/util/call-site.mjs";

const REACT_DEVTOOLS_CALLERS = ["getDataType", "createDehydrated"];

export function calledByDevtools() {
  if (!IS_DEV) return false;

  return callsites().some((callsite) =>
    REACT_DEVTOOLS_CALLERS.includes(callsite.getFunctionName()),
  );
}
